// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2TENc","large":"styles_large__3aNP1"};